<div *ngIf="showLoader">
  <h1 mat-dialog-title class="dialog-title">
    <mat-icon color="primary">info</mat-icon>
    <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
  </h1>
  <glxy-loading-spinner size="large" [fullWidth]="true" [fullHeight]="true" [inline]="false" />
</div>

<div *ngIf="!showLoader && allowEntityDeletion">
  <h1 mat-dialog-title class="dialog-title">
    <mat-icon color="primary">info</mat-icon>
    <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
  </h1>

  <div mat-dialog-content class="dialog-content" *ngIf="!showLoader && allowEntityDeletion">
    <p class="dialog-content">
      {{ categoryContent | translate }}
    </p>
  </div>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="onNoClick()">
      {{ categoryDoNotDelete | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onYesClick()" cdkFocusInitial [disabled]="working">
      <span [ngClass]="{ loading: working }">
        {{ categoryDoDelete | translate }}
      </span>
      <div class="spinner-container" *ngIf="working">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
    </button>
  </mat-dialog-actions>
</div>

<div *ngIf="!showLoader && !allowEntityDeletion">
  <h1 mat-dialog-title class="dialog-title">
    <mat-icon color="warn">warning</mat-icon>
    <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
  </h1>

  <div mat-dialog-content class="dialog-content">
    <p>{{ categoryContent | translate }}</p>
    <br />
    <div *ngIf="service">
      <b>
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE.CANNOT_DELETE.HEADER' | translate: { count: service.length } }}
      </b>
      <p>{{ service.join(', ') }}.</p>
    </div>
    <div *ngIf="group">
      <b> {{ 'MEETING_SCHEDULER.BOOKING_LINK.GROUP.CANNOT_DELETE.HEADER' | translate: { count: group.length } }} </b>
      <p>{{ group.join(', ') }}.</p>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="onNoClick()">
      {{ categoryDoNotDelete | translate }}
    </button>
  </mat-dialog-actions>
</div>
